import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import InfoButton from '../PageWide/InfoButton';
import { ProfileObject, learningCertificates, recommendations } from '../../BLL/Profile';
import LinkListDisplay from '../PageWide/LinkListDisplay';
import Article from '../PageWide/Article';
import { FaGithub, FaLinkedin, FaGitAlt, FaEnvelope, FaRobot, FaCircleArrowLeft, FaCircleArrowRight, FaDiscord } from "react-icons/fa6";
import profileImg from '../../media/img/icons/github-dark.png';
import SelectionInput from '../Portfolio/SelectionInput';
import HexLinks from '../Portfolio/HexLinks';
import profileImage from '../../media/img/profile.JPG';

function SplashPageFeature() {
  const topLinks = [
    { to: '/about', label: 'Story' },
    { to: '/portfolio', label: 'Work' },
    { to: '/playground', label: 'Play' }
  ];

const [activeSection, setActiveSection] = useState(null);
const [reviewIndex, setReviewIndex] = useState(0);
const [linkLearning, setLinkLearning] = useState(false);
const [recommendationStatus, setRecommendationStatus] = useState(false);
const [profilePicOpen, setProfilePic] = useState(false);
const reviewsRef = useRef(null);
const experienceRef = useRef(null);

const linkedInProfile = ProfileObject.linkedIn.linkUrl;
const resume = ProfileObject.resume;

const handleExpand = (section) => {
  setActiveSection(prev => (prev === section ? null : section));
};
function handleReviewArrow(direction) {
  setReviewIndex(prevIndex => {
    if (direction === "left") {
      return prevIndex <= 0 ? recommendations.length - 1 : prevIndex - 1;
    } else if (direction === "right") {
      return prevIndex >= recommendations.length - 1 ? 0 : prevIndex + 1;
    }
    return prevIndex;
  });
}

  return (
    <section className="home-page">
      <div className="splash-btn-wrapper mt-75 mb-25">
        <div className="f-col pd-25">
          <div className="profile-container">
            <h2>
              My Name is Dave Sommerville
            </h2>
            <img className={`profile-hex ${profilePicOpen ? 'large' : ''}`} src={profileImage} onClick={() =>setProfilePic(!profilePicOpen)}></img>
          </div>
          <p>
            I love writing code. I love turning ideas into real, functioning things. Through my education then employment with MITT in the Software Development Program, I discovered an unstoppable passion for coding.  Due to the recent closure of MITT, I am once again seeking employment. I'm also available for freelance work or collaboration and continually developing my personal portfolio. Please reach out to connect if interested.
          </p>
          <a href="/data/Resume_2026.pdf" target="_blank" rel="noopener noreferrer">View My Resume</a>
        </div>
        <div className={`splash-info-btn-wrapper ${activeSection ? 'open' : ''}`}>
          <InfoButton
            ref={reviewsRef}
            label="Skills"
            isActive={activeSection === 'Skills'}
            onClick={() => handleExpand('Skills')}
          >
            <div>
              <h4>Development Languages</h4>
              <p>
                HTML, CSS, JavaScript, C#, Python, PHP, Bash, Node.js
              </p>
              <h4>Databases & Data Management</h4>
              <p>
                SQL Server, MySQL, SQLite, Linq, ORM Tools
              </p>
              <h4>Frameworks & Libraries</h4>
              <p>
                React, ASP.NET, Socket.IO, Flask
              </p>
              <h4>Version Control, Testing, and Deployment</h4>
              <p>
                NUnit, Moq, SOAP UI, Git, GitHub(CI/CL Pipelines), Docker, Power Automate, XAMP
              </p>
              <h4>Other</h4>
              <p>
                Microsoft 365 Suite, PeopleSoft, Figma, Jira, Verint, CRM Platforms (Salesforce-style tools, generalized)
              </p>
            </div>
          </InfoButton>
          <InfoButton
            ref={experienceRef}
            label="Experience"
            isActive={activeSection === 'Experience'}
            onClick={() => handleExpand('Experience')}
          >
            <ul className="mb-25">
              <li>2 years Full Stack Web Development</li>
              <li>Other Experience:</li>
              <li>6 years Management</li>
              <li>4 years sales</li>
              <li>6 years Hospitality</li>
              <li>8 years Administration</li>
            </ul>
          </InfoButton>
        </div>
        
      </div>
      <div className="splash-btn-wrapper">
        <h3 className="rec-title" onClick={() => setRecommendationStatus(!recommendationStatus)}>
          [ Recommendations ]
        </h3>
        <div className={`recommendations ${recommendationStatus ? "open" : ""}`}>
          <div className="flex space-between">
            <div onClick={() => handleReviewArrow("left")}>
              <FaCircleArrowLeft  className="btn"></FaCircleArrowLeft>
            </div>
            <a
              href={recommendations?.[reviewIndex]?.linkedInUrl || "#"}
              target="_blank"
              rel="noopener noreferrer"
              >
              <p>{recommendations?.[reviewIndex]?.name || "Name"}</p>
            </a>
            <div onClick={() => handleReviewArrow("right")}>
              <FaCircleArrowRight  className="btn"></FaCircleArrowRight>
            </div>
          </div>
          <p className="t-cen review-text">{recommendations?.[reviewIndex]?.review || "Review text"}</p>
        </div>
      </div>
      <HexLinks></HexLinks>
    </section>
  );
}

export default SplashPageFeature;
